import React, { useCallback } from 'react';
import FileUpload from '@rd-web-markets/shared/dist/util/FileUpload';
import { useFileUpload } from '@rd-web-markets/shared/dist/hooks';
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import { useTranslation } from 'react-i18next';
import generalService from '@rd-web-markets/shared/dist/services/claim_groups/general_service';
const ElsterFileSection = _ref => {
  let {
    elsterId,
    elster,
    setElster
  } = _ref;
  const {
    t
  } = useTranslation();
  const uploadFile = useErrorHandling(useCallback(async formData => {
    formData.append('claim_group', JSON.stringify({
      id: elsterId
    }));
    const response = await generalService.postFormData(elsterId, 'elster_actions', 'elster_action_attachments', formData);
    const currentElster = elster.elster_actions.find(elster => elster.id === elsterId);
    delete currentElster.file;
    currentElster.file = {
      ...response.file
    };
    setElster({
      ...elster
    });
  }, []));
  const [file, isFileUploadLoading, setFile] = useFileUpload(uploadFile);
  return /*#__PURE__*/React.createElement(FileUpload, {
    loading: isFileUploadLoading,
    title: t('upload_document'),
    file: file,
    onSelectFile: setFile,
    classesForDefaultBody: "d-flex"
  });
};
export default ElsterFileSection;